import React, {Component} from 'react';
import {Container, Row, Col} from 'reactstrap';
import { withRouter } from 'react-router-dom';

import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { auth } from '../../../firebase';
import firebase from 'firebase';
import firebaseui from 'firebaseui';

// Configure FirebaseUI.
const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: 'popup',
  // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  signInSuccessUrl: '/',
  // We will display Google and Facebook as auth providers.
  signInOptions: [
	firebase.auth.EmailAuthProvider.PROVIDER_ID
    // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
	// firebase.auth.TwitterAuthProvider.PROVIDER_ID,
	// firebase.auth.GithubAuthProvider.PROVIDER_ID,
  ],
  // Required to enable one-tap sign-up credential helper.
  credentialHelper: firebaseui.auth.CredentialHelper.NONE
};

class Login extends Component {
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
				<a href="http://www.senseev.com/" title="SenseEV"><img src="/img/logo.png" width="100%"/></a>
				<br/><br/>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8">
				<p>Please sign in with your SenseEV email address and password.
				If you do not have a SenseEV account yet, please enter the email address you wish to use.</p>
				<p>Note: Please use a different password for SenseEV than you use for Tesla.</p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8">
				<StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js